import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'hi-beta-tag-component',
  standalone: true,
  imports: [],
  templateUrl: './beta-tag-component.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './beta-tag-component.component.scss',
})
export class BetaTagComponentComponent {}
